import axios from 'axios'
import { getSavedState, saveState, getRecaptchaV3Token } from '@state/helpers'
import _ from 'lodash'
import { recaptchaActions } from '@utils/appConstants'

export const state = {
  vehicle: getSavedState('vhr.vehicle'),
  showSummary: getSavedState('vhr.showSummary'),
}

export const getters = {}

export const mutations = {
  UPDATE_VEHICLE(state, vehicle) {
    state.vehicle = vehicle
    saveState('vhr.vehicle', vehicle)
    state.showSummary = true
    saveState('vhr.showSummary', true)
  },
  UPDATE_SUMMARY(state, newValue) {
    state.showSummary = newValue
    saveState('vhr.showSummary', newValue)
    state.vehicle = {}
    saveState('vhr.vehicle', {})
  },
}

export const actions = {
  async getVinSummary({ commit, state }, vin) {
    let recaptchaToken = null
    try {
      recaptchaToken = await getRecaptchaV3Token(recaptchaActions.vinSearch)
    } catch (e) {
      // Don't rethrow error, in case google is down we still want to return data.
      console.error(e)
    }

    return (
      axios
        // path is 'consumer-api
        .get(`/consumer-api/meta/v1/summary/${vin}`, {
          headers: { recaptchaToken: recaptchaToken },
        })
        .then((response) => {
          commit('UPDATE_VEHICLE', response.data[0])
          return response.data[0]
        })
        .catch((error) => {
          // Reject the promise is required to trigger error on response
          return Promise.reject(error.response.data.message)
        })
    )
  },
  async getVinFloodSummary({ commit, state }, vin) {
    let floodRiskToken = null
    try {
      floodRiskToken = await getRecaptchaV3Token(
        recaptchaActions.floodRiskCheck
      )
    } catch (e) {
      // Don't rethrow error, in case google is down we still want to return data.
      console.error(e)
    }

    const floodRiskSummary = await axios
      // path is 'consumer-api
      .get(`/consumer-api/floodriskindicators/v1/vin/${vin}`, {
        headers: { recaptchaToken: floodRiskToken },
      })
      .then((response) => {
        return _.get(response, 'data.floodRiskIndicators.vehicle[0]')
      })
      .catch((error) => {
        // Reject the promise is required to trigger error on response
        return Promise.reject(error.response.data.message)
      })

    let summaryRecaptchaToken = null
    try {
      summaryRecaptchaToken = await getRecaptchaV3Token(
        recaptchaActions.vinSearch
      )
    } catch (e) {
      console.error(e)
    }

    const vinSummary = await axios
      // path is 'consumer-api
      .get(`/consumer-api/meta/v1/summary/${vin}`, {
        headers: { recaptchaToken: summaryRecaptchaToken },
      })
      .then((response) => {
        commit('UPDATE_VEHICLE', response.data[0])
        return response.data[0]
      })
      .catch((error) => {
        // Reject the promise is required to trigger error on response
        return Promise.reject(error.response.data.message)
      })

    return {
      floodRiskSummary,
      vinSummary,
    }
  },
  async getVinRecallSummary({ commit, state }, vin) {
    let recallRecaptchaToken = null
    try {
      recallRecaptchaToken = await getRecaptchaV3Token(
        recaptchaActions.recallCheck
      )
    } catch (e) {
      // Don't rethrow error, in case google is down we still want to return data.
      console.error(e)
    }

    return (
      axios
        // path is 'consumer-api
        .get(`/consumer-api/recallsummary/v1/vin/${vin}`, {
          headers: { recaptchaToken: recallRecaptchaToken },
        })
        .then((response) => {
          return response.data
        })
        .catch((error) => {
          // Reject the promise is required to trigger error on response
          return Promise.reject(error.response)
        })
    )
  },
  async getPlateSummary({ commit, state }, { plate, selectedState }) {
    let plateRecaptchaToken = null
    try {
      plateRecaptchaToken = await getRecaptchaV3Token(
        recaptchaActions.plateSearch
      )
    } catch (e) {
      // Don't rethrow error, in case google is down we still want to return data.
      console.error(e)
    }

    return (
      axios
        // path is 'consumer-api
        .get(
          `/consumer-api/meta/v1/summary/plate/${plate}/state/${selectedState}`,
          {
            headers: { recaptchaToken: plateRecaptchaToken },
          }
        )
        .then((response) => {
          const searchResults =
            response.data.length > 1
              ? {
                  results: response.data,
                  multiple: true,
                }
              : {
                  results: response.data[0],
                  multiple: false,
                }

          if (!searchResults.multiple) {
            commit('UPDATE_VEHICLE', response.data[0])
          }

          return searchResults
        })
        .catch((error) => {
          // Reject the promise is required to trigger error on response
          return Promise.reject(error.response.data.message)
        })
    )
  },
  getFullReport({ commit, state }, { vin, type, isOwner }) {
    let queryString = ''
    if (isOwner !== undefined) {
      queryString = `?isOwner=${isOwner}`
    }
    return (
      axios
        // path is 'consumer-api
        .get(
          `/consumer-api/vin/v1/fullreport/${vin}/type/${type}${queryString}`
        )
        .then((response) => {
          return response.data
        })
        .catch((error) => {
          // Reject the promise is required to trigger error on response
          return Promise.reject(error.response.data.message)
        })
    )
  },
  updateSummary({ commit, state }, newValue) {
    commit('UPDATE_SUMMARY', newValue)
  },
}
